export default __webpack_public_path__ + "static/img/vogue_scene_animated_0608.4c93b18.webp";